export default {"src":"/_next/static/media/glide.ec140190.svg","height":31,"width":100};